import { useApolloClient } from '@apollo/client/react'
import { archiveSession } from '../../../api'

const useArchiveSession = () => {
  const client = useApolloClient()

  const archiveSessionMutation = (session) => {
    return archiveSession({ client, session })
  }
  return { archiveSessionMutation }
}

export default useArchiveSession
